import { render, staticRenderFns } from "./AddEditCreditors.vue?vue&type=template&id=1fac7046&scoped=true&"
import script from "./AddEditCreditors.vue?vue&type=script&lang=js&"
export * from "./AddEditCreditors.vue?vue&type=script&lang=js&"
import style0 from "./AddEditCreditors.vue?vue&type=style&index=0&id=1fac7046&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fac7046",
  null
  
)

export default component.exports